import { apiCall } from "./authServieces";

export const FetchWabaData = async (endpoint) =>{
    try{
        const response = await apiCall({
            endpoint: endpoint,
            method: "GET",
        });
        return response; 
    }catch(error){
        throw error;
    }
}

export const CheckApiKeyAndPassword = async (adminId, apiParams, apiCheck) => {
    try{
        let endpoint;
        if (apiCheck === "key"){
            // endpoint = `api/admin/check-api-key-password/${adminId}?apiKey=${apiParams}`
            endpoint = `api/manage-waba/check-api-key-password?apiKey=${apiParams}`
        }else{
            // endpoint = `api/admin/check-api-key-password/${adminId}?apiKeyPassword=${apiParams}`
            endpoint = `api/manage-waba/check-api-key-password?apiKeyPassword=${apiParams}`
        }
        const response = await apiCall({
            endpoint: endpoint,
            method: "GET",
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const WabaApiKey = async(adminId, wabaApiKey) => {
    try{
        const response = await apiCall({
            // endpoint: `api/admin/check-waba-api-key/${adminId}?wabaApiKey=${wabaApiKey}`,
            endpoint: `api/manage-waba/check-waba-api-key?wabaApiKey=${wabaApiKey}`,
            method: 'GET',
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const CheckBusinessNumber = async(businessNumber, adminId) => {
    try{
        const response = await apiCall({
            // endpoint: `api/admin/check-business-api-key/${adminId}?businessNumber=${businessNumber}`,
            endpoint: `api/manage-waba/check-business-api-key?businessNumber=${businessNumber}`,
            method: 'GET',
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const CheckWabaId = async (wabaId, userId) => {
    try{
        const response = await apiCall({
            // endpoint: `api/admin/check-waba-id/${userId}?wabaId=${wabaId}`,
            endpoint: `api/manage-waba/check-waba-id?wabaId=${wabaId}`,
            method: 'GET',
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const AddNewWaba = async ({payload}) => {
    try{
        const response = await apiCall({
            endpoint: "api/manage-waba/add-new-waba",
            method: "POST",
            payload: payload,
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const UpdatePriceDetails = async ({payload}, priceId, businessNumber, userId) => {
    try{
        const endpoint = `api/manage-waba/update-price/${priceId}/${businessNumber}/${userId}`;
        const response = await apiCall({
            endpoint: endpoint,
            method: "PATCH",
            payload: payload,
        });
        return response;
    }catch(error){
        throw error;
    }
}

export const UpdateWabaDetails = async ({payload}, wabaId, businessNumber, userId) => {
    try{
        const endpoint = `api/manage-waba/update-waba/${wabaId}/${businessNumber}/${userId}`;
        const response = await apiCall({
            endpoint: endpoint,
            method: "PATCH",
            payload: payload,
        });
        return response;
    }catch(error){
        throw error;
    }
}